<template>
  <div>
    <div
      ref="pdfContent"
      class="d-flex flex-column"
    >
      <b-img
        class="mx-auto mt-2"
        :src="require('@/assets/images/logo/logoGrandCapital.svg')"
        width="150"
      />
      <!-- <p class="text-center mt-1 font-weight-bold">
        ДОГОВОР № {{ contractContent.contract_number }}
      </p> -->
      <p class="text-center mt-1 mx-5 px-5 font-weight-bold">
        {{ contractContent.header }}
      </p>
      <div
        class="mt-2 px-4 text-justify"
        v-html="contractContent.main_part"
      />
      <section
        v-for="(clause, index) in contractContent.clauses"
        :key="index"
        class="px-4 text-justify"
      >
        <p class="font-weight-bold text-center text-uppercase">
          {{ index + 1 }}. {{ clause.title }}
        </p>
        <b-row
          v-for="(subclause, ind) in clause.subclauses"
          :key="ind"
        >
          <b-col md="1">
            <p class="mb-0 font-weight-bold">
              {{ subclause.key }}
            </p>
          </b-col>
          <b-col
            md="11"
            v-html="subclause.value"
          />
        </b-row>
      </section>
      <!-- <section>
        <p class="font-weight-bold text-center text-uppercase">
          {{ contractContent.document.clauses.length }}. ЮРИДИЧЕСКИЕ АДРЕСА
          СТОРОН
        </p>
        <b-row>
          <b-col md="6">
            <p class="font-weight-bold text-center text-uppercase">
              Застройщик
              <br>
              ООО {{ contractContent.brand.title }}
            </p>
            <p>
              {{ contractContent.brand.address }}
            </p>
            <p />
            <p>ИНН: {{ contractContent.brand.account.inn }}</p>
            <p>ОКЕД: {{ contractContent.brand.account.oked }}</p>
          </b-col>
          <b-col md="6">
            <p class="font-weight-bold text-center text-uppercase">
              ИНВЕСТОР
            </p>
          </b-col>
        </b-row>
        <p class="font-weight-bold text-center text-uppercase">
          ПОДПИСЫ СТОРОН
        </p>
        <div class="d-flex justify-content-between">
          <div class="border-top">
            {{ contractContent.brand.boss }} Директор
          </div>
          <div class="border-top">
            {{ contractContent.customer_details.name }}
          </div>
        </div>
      </section> -->
    </div>
    <!-- html2canvas: { scale: 1 }, -->
  </div>
</template>

<script>
import {
  BImg,
  BRow,
  BCol,
  // BButton,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
// eslint-disable-next-line
// import * as fontCyr from '@/assets/fonts/Tinos-Regular-normal'
// import * as font from '@/assets/fonts/times-new-roman-normal'
// eslint-disable-next-line
// import * as fontCyr from '@/assets/fonts/times-new-roman-cyr-normal'

export default {
  components: {
    BImg,
    BRow,
    BCol,
    // BButton,
  },
  props: {
    contractContent: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
  },
  computed: {
    ...mapGetters('contracts', ['GET_ONE_CONTRACT']),
  },
  methods: {
    ...mapActions('contracts', ['FETCH_ONE_CONTRACT', 'EDIT_CONTRACT']),
  },
}
</script>

<style lang="scss">
.pdf-content,
.font-family-times {
  font-family: "Times New Roman", Times, serif;
}
</style>
